import React from 'react';
import { Typography } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';

interface MultaMoraDetailsSectionProps {
  percentualMulta?: number | null;
  periodicidadeMulta?: number | null;
  percentualMora?: number | null;
  periodicidadeMora?: number | null;
}

const periodicidadeMultaOptions = [
  { value: '0', description: 'Diário' },
  { value: '1', description: 'Mês' },
  { value: '2', description: 'Ano' }
];

const periodicidadeMoraOptions = [
  { value: '0', description: 'Diário' },
  { value: '1', description: 'Mês' },
  { value: '2', description: 'Ano' }
];

const MultaMoraDetailsSection: React.FC<MultaMoraDetailsSectionProps> = ({
  percentualMulta,
  periodicidadeMulta,
  percentualMora,
  periodicidadeMora
}) => {
  return (
    <Section title={'Atraso do Pagamento e encargos'} defaultGrid>
      <div>
        <Typography variant="body2">{'Juros de Multa - Percentual:'}</Typography>
        <Typography variant="body1">
          {percentualMulta !== undefined && percentualMulta !== null 
            ? `${percentualMulta}%` 
            : 'Não informado'}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Juros de Multa - Periodicidade:'}</Typography>
        <Typography variant="body1">
          {periodicidadeMulta !== undefined && periodicidadeMulta !== null
            ? periodicidadeMultaOptions.find((p: any) => p.value === periodicidadeMulta?.toString())?.description || periodicidadeMulta
            : 'Não informado'}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Juros de Mora - Percentual:'}</Typography>
        <Typography variant="body1">
          {percentualMora !== undefined && percentualMora !== null 
            ? `${percentualMora}%` 
            : 'Não informado'}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Juros de Mora - Periodicidade:'}</Typography>
        <Typography variant="body1">
          {periodicidadeMora !== undefined && periodicidadeMora !== null
            ? periodicidadeMoraOptions.find((p: any) => p.value === periodicidadeMora?.toString())?.description || periodicidadeMora
            : 'Não informado'}
        </Typography>
        <SmSpace />
      </div>
    </Section>
  );
};

export default MultaMoraDetailsSection;
